import * as React from "react"
import type {HeadFC, PageProps} from "gatsby"
import Layout from "../components/Layout";
import {StaticImage} from "gatsby-plugin-image";

const whoWeAre = ['Our team consists of Scientists, Engineers, Researchers & Experts with diversified background and a unique culture committed to producing state-of-the-art numerical models and providing high quality services in challenging applications',
    'Our talented researchers develop accurate and easy-to-use numerical models & our experienced engineers are pragmatic problem-solvers, adept at implementing these models to face real-life problems'];
const whatWeDo = ['We have produced in-house accurate numerical models and design tools, essential for the engineers to plan and design cost efficient and environmentally friendly projects.',
    'We provide professional services and cutting-edge technology to engineering firms and state authorities, helping them to improve their services and address their challenges.',
    'We take initiatives & implement innovative methodologies through applied research projects'];
const AboutUsPage: React.FC<PageProps> = () => {
    return (
        <Layout bg={"bg-[#ECFDF5]"}>
            <StaticImage src={'../images/about-us.png'} placeholder={"none"} alt={"blog cover"}/>
            <h1 className="text-2xl lg:text-5xl py-8 font-semibold text-[#171717] mx-auto text-center max-w-3xl py-4">
                Scientia Maris develops & distributes the world’s first SaaS application for coastal & port engineering simulation
            </h1>
            <p className="mx-auto text-md lg:text-lg font-normal max-w-3xl text-center text-black/[0.6] pt-4 pb-16">We are a team
                with
                deep knowledge and expertise in coastal and port engineering studies based on state-of-the-art numerical
                models. Here you can find out more on our story & background</p>
            <div className="bg-white">
                <div className="w-full max-w-[100rem] mx-auto">
                    <h1 className="text-2xl lg:text-5xl py-8 font-semibold text-[#171717] mx-auto text-center max-w-3xl">
                        Take full advantage of the cloud computing power
                    </h1>
                    <p className="mx-auto text-md lg:text-lg font-normal	max-w-3xl text-center text-black/[0.6]">Complete
                        your simulation projects in a flash, taking advantage of our easy-to-use and efficient
                        web-based simulation software platform</p>
                </div>
                <div className={"grid grid-cols-1 lg:grid-cols-3 mt-8 w-full max-w-[100rem] mx-auto gap-x-4 px-8"}>
                    <div>
                        <h1 className="text-xl		 py-8 font-semibold text-[#171717] mx-auto text-center max-w-3xl">
                            Our Vision </h1>
                        <p className="mx-auto text-base		font-normal	max-w-3xl text-center text-black/[0.6]">Develop
                            best-in-class numerical models and design tools, promote innovation, upgrade strategic
                            planning & design processes and ameliorate living standards globally</p>
                    </div>
                    <div>
                        <h1 className="text-xl		 py-8 font-semibold text-[#171717] mx-auto text-center max-w-3xl">
                            Our Mission </h1>
                        <p className="mx-auto text-base		font-normal	max-w-3xl text-center text-black/[0.6]">To
                            empower engineers and authorities to solving engineering problems in sea water environments,
                            by taking advantage of state-of-the-art numerical models and top-notch research results</p>
                    </div>
                    <div>
                        <h1 className="text-xl		 py-8 font-semibold text-[#171717] mx-auto text-center max-w-3xl">
                            Our Values </h1>
                        <ul className="ml-4 mx-auto text-base list-disc font-normal max-w-3xl text-left text-black/[0.6]">
                            <li>Act with integrity, independence & responsibility</li>
                            <li>Foster a culture of integration: Research – Innovation – Creation</li>
                            <li>Continuously seek collaborations & partnerships with new scientists. “If you want to go
                                fast, go alone. If you want to go far, go together.” African Proverb.
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    className={"flex flex-col lg:flex-row mt-8 w-full max-w-[100rem] mx-auto justify-between py-8 px-8"}>
                    <div>
                        <h1 className="text-4xl	 py-8 font-semibold	 text-[#171717] ">
                            Who we Are </h1>
                        <p className="max-w-xl space-y-1 text-base leading-7 text-gray-600 lg:max-w-xl">
                            {whoWeAre.map((feature, index) => (
                                <div key={index} className="items-start flex gap-x-2">
                                    <div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01"
                                                stroke="#475569" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    {feature}
                                </div>
                            ))}
                        </p>
                    </div>
                    <div>
                        <h1 className="text-4xl	 py-8 font-semibold text-[#171717] max-w-3xl">
                            What We Do </h1>
                        <p className="max-w-xl space-y-1 text-base leading-7 text-gray-600 lg:max-w-xl">
                            {whatWeDo.map((feature, index) => (
                                <div key={index} className="items-start flex gap-x-2">
                                    <div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01"
                                                stroke="#475569" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    {feature}
                                </div>
                            ))}
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default AboutUsPage

export const Head: HeadFC = () => (
    <>
        <title>Scientia Maris | About Us</title>
        <link rel="stylesheet" href="https://rsms.me/inter/inter.css"/>
    </>
)
